import { StakingResponse } from "@services/Funds.service";
import React from "react";

import * as style from "../../StepsStyle.module.scss"

type TransactionStatusBadgeProps = {
  status: StakingResponse["status"];
};

export const TransactionStatusBadge: React.FC<TransactionStatusBadgeProps> = ({
  status,
}) => {
  return <div className={style.transactionStatusBadge}>{status}</div>;
};
